export class CustomerCreditCard {

  cardNumber: string;
  cardHolder: string;
  cardValidityMonth: string;
  cardValidityYear: string;
  cardValidityDate: string;
  cardSecurityCode: string;
  brand: string;
  nickName: string;

  //Adyen
  encryptedCardNumber: string;
  encryptedCardValidityMonth: string;
  encryptedCardValidityYear: string;
  encryptedCardSecurityCode: string;

  constructor(data?: any) {
    if (!data) return;

    this.cardNumber = data.number || data.cardNumber;
    this.brand = data.brand;
    this.cardHolder = data.cardHolder;
    this.cardSecurityCode = data.cardSecurityCode;
    this.nickName = data.nickName;

    //Adyen
    this.encryptedCardNumber = data.encryptedCardNumber;
    this.encryptedCardValidityMonth = data.encryptedCardValidityMonth;
    this.encryptedCardValidityYear = data.encryptedCardValidityYear;
    this.encryptedCardSecurityCode = data.encryptedCardSecurityCode;

    if (data.cardValidityDate) {
      const splittedDate = data.cardValidityDate.split('/');
      this.cardValidityMonth = splittedDate[0];
      this.cardValidityYear = splittedDate[1];
    } else {
      this.cardValidityMonth = data.cardValidityMonth;
      this.cardValidityYear = data.cardValidityYear;
    }
  }
}
